import { render, staticRenderFns } from "./EditJournalContentGroup.vue?vue&type=template&id=2d6f82ad&scoped=true"
import script from "./EditJournalContentGroup.vue?vue&type=script&lang=js"
export * from "./EditJournalContentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f82ad",
  null
  
)

export default component.exports